import { Fetcher } from '@this/src/util';

export interface MileageNumberResponse {
  id: number;
  carrier: string;
  number: string;
}

export interface ExicCardResponse {
  id: number;
  exic_number: string | null;
  organization_id: number;
}

export interface BusinessEkinetAccountResponse {
  id: number;
  business_ekinet_id: string;
}

export interface NamedRefResponse {
  id: number;
  name: string;
}

export interface OrganizationBaseRefResponse {
  id: number;
  name: string | null;
  address: string | null;
}

export interface DepartmentRefResponse {
  id: number;
  name: string;
  code: string;
}

export interface MemberInfoResponseArgs {
  id: number;
  organization_id: number;
  employee_number: string | null;
  last_name: string | null;
  first_name: string | null;
  last_name_kana: string | null;
  first_name_kana: string | null;
  last_name_roman: string | null;
  first_name_roman: string | null;
  gender: string | null;
  birthday: string | null;
  email: string | null;
  tel: string | null;
  disabled: boolean;
  domestic_approval_required: boolean;
  foreign_approval_required: boolean;
  organization: NamedRefResponse | null;
  department: DepartmentRefResponse | null;
  grade: NamedRefResponse | null;
  organization_role: NamedRefResponse | null;
  organization_base: OrganizationBaseRefResponse | null;
  exic_card: ExicCardResponse | null;
  business_ekinet_account: BusinessEkinetAccountResponse | null;
  mileage_numbers: MileageNumberResponse[];
}

export default class MemberAPI {
  static async show(organizationId: number, userId: number): Promise<MemberInfoResponseArgs> {
    return Fetcher.get<MemberInfoResponseArgs>(
      `/arrangement/organizations/${organizationId}/members/${userId}.json`
    );
  }
}
